<script setup lang="ts">
import { PaperClipIcon, CloudArrowUpIcon, ArrowUpTrayIcon } from "@heroicons/vue/24/outline";
import { ref, watch } from 'vue';
import { LoadedFile } from "./types";

const props = defineProps({
  multiple: {
    type: Boolean,
    default: false,
  },
  accept: {
    type: String,
    default: "",
  },
  buttonText: {
    type: String,
    default: "Ajouter un document",
  }
});

const emits = defineEmits<{
  (e: 'filesUpdated', files: LoadedFile[]): void
}>();
const selectedFiles = ref<LoadedFile[]>([]);

function uploadFiles(files: File[]) {
  if (!Array.isArray(files)) return;
  for (const file of files) {
    if (file) {
      const fileReader = new FileReader();
      fileReader.onload = (event: any) => {
        const fileContent = event.target.result;
        selectedFiles.value.push({ file, content: fileContent });
      };
      fileReader.readAsDataURL(file);
    }
  }
};

function removeFile(index: number) {
  selectedFiles.value.splice(index, 1);
}

const dragOver = ref(false);

const setDragOver = (state: boolean) => {
  dragOver.value = state;
};


const onDrop = (event: DragEvent) => {
  event.preventDefault();
  dragOver.value = false;

  const files: File[] = Array.from(event.dataTransfer?.files || []);
  uploadFiles(files);

  // if (selectedFiles.some(file => file.type.split("/")[0] !== "image")) {
  //   fileDropError.value = "Please provide only image files to upload!";
  //   return;
  // }

  // selectedFiles.value = [...files, ...selectedFiles.value];
  // fileDropError.value = "";
};

watch(selectedFiles.value, (newValue) => {
  emits('filesUpdated', newValue);
});
</script>

<template>
  <div class="mt-2">
    <ul v-if="selectedFiles.length" role="list" class="my-4 border border-blue-200 divide-y divide-blue-100 rounded-md bg-blue-50">
      <li v-for="({ file }, index) in selectedFiles" :key="index" :id="`${index}-${file.name}`" class="flex items-center justify-between py-4 pl-4 pr-5 text-sm leading-6">
        <div class="flex items-center flex-1 w-0">
          <PaperClipIcon class="flex-shrink-0 w-5 h-5 text-blue-900" aria-hidden="true" />
          <div class="flex flex-1 min-w-0 gap-2 ml-4">
            <span v-tooltip.bottom="file.name" class="font-medium text-blue-900 truncate">{{ file.name }}</span>
            <span class="flex-shrink-0 text-blue-700">{{ (file.size / 1024).toFixed(2) }} ko</span>
          </div>
        </div>
        <div v-show="true" class="flex flex-shrink-0 ml-4 space-x-4">
          <!-- <button type="button" class="font-medium text-blue-600 rounded-md hover:text-blue-500">Update</button> -->
          <!-- <span class="text-blue-200" aria-hidden="true">|</span> -->
          <button type="button" @click="removeFile(index)" class="font-medium text-blue-900 rounded-md hover:text-blue-800">
            Supprimer
          </button>
        </div>
      </li>
    </ul>
    <div
      v-if="!selectedFiles.length"
      class="inline-flex items-center w-full mx-auto text-sm font-semibold text-gray-900 transition-all bg-white rounded-lg cursor-pointer">
      <!-- <label class="inline-flex items-center cursor-pointer  gap-x-1.5 px-1">
        <ArrowUpTrayIcon class="-ml-0.5 h-5 w-5 text-gray-600" aria-hidden="true" />
        {{ props.buttonText }}
        <input type="file" @change="uploadFiles" :multiple="multiple" :accept="props.accept" class="hidden w-full" />
      </label> -->

      <form @submit.prevent v-if="!selectedFiles.length" class="w-full ">
        <label
          for="file"
          @dragover.prevent="setDragOver(true)"
          @dragleave="setDragOver(false)"
          @drop="(e) => onDrop(e as any)"
          class=""
          :class="[
            'px-4 py-2 border-[1.5px]  border-dashed m-2 hover:bg-gradient-to-b hover:border-blue-400 hover:from-zinc-50 hover:to-blue-50 rounded-xl flex flex-col justify-start items-center hover:cursor-pointer',
            dragOver ? 'border-blue-600 bg-blue-50' : 'bg-slate-50'
          ]"
        >
          <div class="flex flex-col items-center justify-start">
            <CloudArrowUpIcon
              class="w-8 h-8 my-4 text-neutral-600"
              :class="{ 'text-blue-500': dragOver }"
            />
            <p class="font-semibold">Glisser déposer ici</p>
            <p class="text-sm text-neutral-500">Priviligier les PDF · Jusqu'à 350 MB.</p>
            <div class="px-3 py-1 mt-4 mb-2 transition-all bg-white border rounded-xl drop-shadow-sm hover:drop-shadow hover:cursor-pointer">
              Sélectionner un fichier
            </div>
          </div>
        </label>
        <input
          type="file"
          name="file"
          id="file"
          class="hidden"
          @change="(event: any) => uploadFiles(Array.from(event.target.files))"
          :accept="accept"
          :multiple="multiple"
        />
      </form>

    </div>
  </div>
</template>